import styled from "styled-components";

export const FooterWidgetStyled = styled.div`
  position: relative;
  .footer_layout {
    padding: 70px 16px;
    background-color: ${({ theme }) => theme.COLORS.BLACK_5};
    .footer_container {
      margin: auto;
      width: 100%;
      max-width: ${({ theme }) => theme.ETC.BODY_CONTAINER_WIDTH};
      display: flex;
      flex-wrap: wrap;
      gap: 200px;
      .footer_column1 {
        .logo {
          margin-bottom: 20px;
        }
        .text_column1 {
          margin-top: 100px;
          font-size: 14px;
          color: ${({ theme }) => theme.COLORS.WHITE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S10};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
        }
      }
      .footer_column234 {
        display: flex;
        flex-direction: column;
        .column234_text {
          margin-bottom: 14px;
          border-bottom: 1px solid transparent;
          color: ${({ theme }) => theme.COLORS.WHITE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LMEDIUM};
          text-decoration: none;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .footer_logo_layout {
    margin: auto;
    padding: 50px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.COLORS.PURPLE_1};
    .footer_logo {
      width: 126px;
      height: auto;
    }
    .footer_social_media_account_list {
      display: flex;
      gap: 16px;
      .footer_social_media_account_item {
        width: 24px;
        height: 24px;
      }
    }
  }

  .footer_copyright {
    margin: auto;
    padding: 10px 16px;
    max-width: ${({ theme }) => theme.ETC.BODY_CONTAINER_WIDTH};
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ftc_left_col {
      display: flex;
      gap: 20px;
      a {
        text-decoration: none;
        color: ${({ theme }) => theme.COLORS.BLACK_5};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .ftc_right_col {
      color: ${({ theme }) => theme.COLORS.BLACK_5};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
  .ArrowDownCircle_button {
    position: fixed;
    bottom: 24px;
    right: 184px;
    cursor: pointer;
    z-index: 99;
    transition: opacity 0.3s ease;
    svg {
      transition: 0.3s ease;
      circle {
        transition:
          fill 0.3s ease,
          stroke 0.3s ease;
      }
      path {
        transition: fill 0.3s ease;
      }
    }
    &:hover {
      svg {
        circle {
          fill: ${({ theme }) => theme.COLORS.PURPLE_1};
          fill-opacity: 1;
          stroke: white;
        }
        path {
          fill: white;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.IPAD}) {
    .footer_layout {
      padding: 70px 90px;
      .footer_container {
        gap: 110px;
      }
      .ArrowDownCircle_button {
        right: 120px;
      }
    }
  }
`;
